const USER_LOCAL_STORAGE_KEY = 'user';
const EMAIL_LOCAL_STORAGE_KEY = 'email';
const SAVE_EMAIL_LOCAL_STORAGE_KEY = 'saveEmail';

export {
  USER_LOCAL_STORAGE_KEY,
  EMAIL_LOCAL_STORAGE_KEY,
  SAVE_EMAIL_LOCAL_STORAGE_KEY,
};
